import { TelFortuneChatRoom } from "shared/models";
import httpClient from "shared/repositories/HttpClient";

const CallRepository = {
  get: async (orderId: number) => {
    const res = await httpClient.miror.get(`/calls?order_id=${orderId}`);
    return new TelFortuneChatRoom(res.data.telFortuneChatRoom);
  },
};

export default CallRepository;
